/*
 * Aliases for c2 APIs that were renamed (not removed) during the
 * c2Archive -> c2 (Bootstrap 5) migration, so customer XUI code written
 * against the old names keeps working.
 *
 * The zz_ filename prefix is deliberate: v5/gulpfile.js concatenates the
 * js/c2/*.js glob alphabetically, so this file must sort after every real
 * module to see the final, complete c2 namespace. Each alias is guarded
 * with `if (!c2.x)` so a future real implementation always wins.
 */

(function (c2) {
  'use strict';

  // c2.tooltip was renamed to c2.tooltips.
  if (!c2.tooltip) {
    c2.tooltip = c2.tooltips;
  }

  // 13 server-stat chart members moved from c2.charts to c2.chartsServerStats.
  // Graft them back onto c2.charts by iterating the namespace, so the two
  // cannot drift apart as members are added or removed from chartsServerStats.
  if (c2.charts && c2.chartsServerStats) {
    Object.keys(c2.chartsServerStats).forEach(function (name) {
      if (!c2.charts[name]) {
        c2.charts[name] = c2.chartsServerStats[name];
      }
    });
  }
})(window.c2);
